









































import { Component, Vue, Prop } from "vue-property-decorator";
import { ParticaListContent } from "../../../Models/ParticaListModel";
import ParticaMenu from "@/Ui-Components/Common/ParticaMenu/ParticaMenu.vue";
import { ListItemDTO } from "../../../Generated/ParticaAPI";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { ButtonConfig } from "../../../Models/Buttons";


@Component({
	name: "ParticaList2Line",
	components: { ParticaMenu, ButtonList }
})
export default class ParticaList2Line extends Vue {
	@Prop() private data: ParticaListContent;
	@Prop() private buttons: ButtonConfig[];

	private click(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

	private created() {
		if (!this.data) {
			throw new Error("data is undefined.");
		}
		if (!this.buttons) {
			throw new Error("buttons is undefined.");
		}
	}
	private handleEvent(event: ParticaEvent) {
		this.$emit("partica-event", event);
	}

}
